import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseIcon from '@mui/icons-material/Pause';
import { CronStatusIconProps } from 'src/components/Cron/CronStatusIcon.types';

export const CronStatusIcon: React.FC<CronStatusIconProps> = ({ isEnabled }) => {
  return isEnabled ? <CheckCircleIcon color="success" /> : <PauseIcon color="error" />;
};
